export const menuReveal= () => {
    let list = document.querySelector(".nav__list");
    let menuIcon = document.querySelector(".menu-icon");
    menuIcon.addEventListener("click",()=>{
        list.classList.toggle("nav__list--active");
    })

 
}